import * as yup from "yup";
import { newCampaignSchema } from "./schema";

export type NewCampaignSchema = yup.InferType<typeof newCampaignSchema>;

export enum ScriptCreation {
  Manual = "manual",
  AI = "ai",
}

export enum PriceProductEnum {
  No = "no",
  Yes = "yes",
  GiftCard = "gift card",
}

export enum RightsOfUseEnum {
  ThreeMonths = "three months",
  SixMonths = "six months",
  TwelveMonths = "twelve months",
  Forever = "forever",
}

export enum ContentObjectiveEnum {
  Awareness = "awareness",
  Nutrition = "nutrition",
  Conversion = "conversion",
  Customizable = "customizable",
}

export enum PostContentTypeEnum {
  Video = "VIDEO",
  Image = "IMAGE",
}

export enum PrivateEnum {
  Private = "private",
  Public = "public",
}
